/**
 * Where a tapped notification should take the user.
 *
 * Notification links are store-relative paths ("/shop", "/account?tab=orders").
 * A storefront served under a path prefix (`/t/<slug>/…` — the layout every
 * native app build uses) must have that prefix put back, otherwise the app
 * leaves its own store: the router has nothing to render (blank screen) and
 * a browser lands on the platform's default store.
 */

/** "/t/<slug>" when the current page is under a tenant path prefix, else "". */
export function tenantBasePath(pathname) {
  const m = /^\/t\/[^/]+/.exec(pathname || "");
  return m ? m[0] : "";
}

/**
 * Resolve a notification link against the page it is opened from.
 * External (http/https) links and links that already carry a `/t/<slug>`
 * prefix are returned unchanged.
 */
export function tenantScopedLink(url, pathname) {
  const link = typeof url === "string" && url.trim() ? url.trim() : "/";
  if (!link.startsWith("/") || link.startsWith("//")) return link;
  if (/^\/t\/[^/]+/.test(link)) return link;
  return `${tenantBasePath(pathname)}${link}`;
}
